import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-confirm-delete',
    template: `
    <header class="modal-header p-3 p-md-4">
      <h4 class="modal-title" i18n>{{ title }}</h4>
    </header>

    <section class="modal-body p-3 p-md-4">
      <span i18n>{{ message }}</span>
    </section>

    <footer
      class="modal-footer justify-content-center align-items-center justify-content-md-between flex-column-reverse flex-md-row p-3 p-md-4"
    >
      <button
        type="button"
        class="btn btn-lg btn-secondary w-100 w-md-auto mb-2 mb-md-0"
        (click)="activeModal.dismiss()"
        i18n
      >{{ cancelButtonText }}</button>
      <button
        type="button"
        class="btn btn-lg btn-primary w-100 w-md-auto"
        (click)="activeModal.close(true)"
        i18n
      >{{ confirmButtonText }}</button>
    </footer>
  `,
    styles: [`
  `],
    standalone: false
})
export class ConfirmDeleteComponent {
  @Input() title: string = 'Löschen';
  @Input() message: string = 'Sind Sie sicher, dass Sie diese Aktion durchführen möchten? Diese Aktion kann nicht rückgängig gemacht werden.';
  @Input() confirmButtonText: string = 'Löschen';
  @Input() cancelButtonText: string = 'Abbrechen';

  constructor(public activeModal: NgbActiveModal) {}
}
